import { render } from "./MtnCongo.vue?vue&type=template&id=24739b0c&scoped=true"
import script from "./MtnCongo.vue?vue&type=script&lang=js"
export * from "./MtnCongo.vue?vue&type=script&lang=js"

import "./MtnCongo.vue?vue&type=style&index=0&id=24739b0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24739b0c"]])

export default __exports__